export default __webpack_public_path__ + "static/media/image.1a90b425.svg";